import styled from '@emotion/styled';

/** 게시판·표·목록 공통 패널 */
export const ContentPanel = styled.div`
	width: 100%;
	background-color: #fff;
	border: 1px solid ${(props) => props.theme.colors.gray100};
	border-radius: ${(props) => props.theme.effects.radiusLg};
	box-shadow: ${(props) => props.theme.effects.shadowSm};
	overflow: hidden;
`;

export const ContentPanelInner = styled.div`
	padding: 2.4rem;
	@media screen and (max-width: 900px) {
		padding: 1.6rem;
	}
`;

/** 안내·규정 페이지 그리드 표 래퍼 */
export const TablePanel = styled(ContentPanel)`
	padding: 0;
`;
